import { render, staticRenderFns } from "./QualificationDownload.vue?vue&type=template&id=58d30a0f&scoped=true"
import script from "./QualificationDownload.vue?vue&type=script&lang=js"
export * from "./QualificationDownload.vue?vue&type=script&lang=js"
import style0 from "./QualificationDownload.vue?vue&type=style&index=0&id=58d30a0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d30a0f",
  null
  
)

export default component.exports